import React from "react";
import "../App.css";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { getVendorEquipmentList, getVendorList, deleteVendorDetails } from "../Actions/VendorManagementAPI";
import { getApplicableSeviceTypewithIdList } from "../Actions/helpersAPI";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { deleteVendor } from "../helpers/api";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import { confirmAlert } from "react-confirm-alert";
import { OverlayTrigger, Popover } from "react-bootstrap";
import i18n from "./DropdownLanguage/i18n";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class VendorManagementDetails extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    console.log("id", match.params.id);
    dispatch(getApplicableSeviceTypewithIdList());
    dispatch(getVendorEquipmentList(match.params.id));
    dispatch({ type: "SubBannerTitle", data: "Vendor Management" });
  }

  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("IntervelScreen.Edit")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  renderdelete(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("CommonText.Delete")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { VendorEquipmentDetailList, pageSize, totalRecords, t } = this.props;
    return (
      <div className="full-height">
        <div className="row mt-3">
          <button
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue m-2 ml-3"
            onClick={() => this.hideSidePanel()}
            style={{display:'inline-flex',alignItems:'center'}}
          >
           <span style={{marginTop:'-1px'}}>&larr;</span>{t("CommonText.Back")}
          </button>
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}>
                        {t("VendorManagementScreenContent.EquipmentVendorsList")}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.renderCardData()}
          </div>
        </div>
      </div>
    );
  }
  hideSidePanel() {
    const { dispatch, history } = this.props;
    history.push(`/Home/VendorManagement`);
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "getVendorEquipmentDetailSuccess", data: item });
    history.push(
      `/Home/VendorManagementEditItem/${item.equipmentId}/${item.vendorId}`
    );
  }

  deleteVendor(item) {
    const { match, t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, VendorList } = this.props;
            let vendor = {
              vendorId: item.vendorId,
              vendorName: item.vendorName,
              isDeleted: true,
              modifiedBy: currentuser.email,
              equipmentName: item.equipmentName,
              serviceTypeId: item.serviceTypeId.toString(),
              zoneId: item.zoneId,
              country: item.countryName,
              port: item.portName,
              createdBy: "",
              price: item.price,
              unitId: item.unitId,
              quantity: item.quantity,
            };
            let url = `${API.postVendor}`;
            axios
              .post(url, vendor)
              .then((response) => {
                dispatch(getVendorEquipmentList(match.params.id));

                dispatch({
                  type: "deleteVendorDetailSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "deleteVendorDetailFailure",
                  error: "ERROR",
                });
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }
  renderCardData = () => {
    const { VendorEquipmentDetailList, editEquipmentDetailsPane, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return VendorEquipmentDetailList &&
      VendorEquipmentDetailList.length !== 0 ? (
      VendorEquipmentDetailList.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}>
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 m-auto">
                    <div className="row px-4">
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("ShipEquipmentStatusScreen.EquipmentName")} : </strong>
                          <span className="italicFont">
                            {" "}
                            {item?.equipmentName}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <span>
                          <strong>{t("VendorManagementScreenContent.VendorName")} : </strong>
                          <span className="italicFont">
                            {item?.vendorName ? item?.vendorName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <span>
                          <strong>{t("ZoneScreen.Title")} : </strong>
                          <span className="italicFont">
                            {item?.zoneName ? item?.zoneName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span>
                          <strong>{t("EquipmentServiceTypes.Country")} : </strong>
                          <span className="italicFont">
                            {item?.countryName ? item?.countryName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <span>
                          <strong>{t("TopPaneContent.Port")} : </strong>
                          <span className="italicFont">
                            {item?.portName ? item?.portName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <span>
                          <strong>{t("TopPaneContent.Unit")} : </strong>
                          <span className="italicFont">
                            {item?.unitName ? item?.unitName : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("content.Servicetype")}  </strong>
                          <strong>:</strong>
                          
                        </span>
                        <span className="italicFont">
                            {item?.serviceTypeName ? item?.serviceTypeName : ""}
                          </span>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("ShipEquipmentStatusScreen.Quantity")}  </strong>
                          <strong>:</strong>
                          <span className="italicFont">
                            {item?.quantity ? item?.quantity : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 mb-2">
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("VendorManagementScreenContent.Price")}  </strong>
                          <strong>:</strong>
                          <span className="italicFont">
                            {item?.price ? item?.price : ""}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-3 col-3 m-auto">
                    <div className="text-right">
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderedit()}
                      >
                        <i
                          className="fa fa-edit fa-lg click m-1 px-1"
                          onClick={() => this.eyeclick(item)}
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: "1.8rem" }}
                        ></i>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderdelete()}
                      >
                        <i
                          className="fa fa-trash click m-1 px-2"
                          onClick={() => this.deleteVendor(item)}
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: "1.8rem" }}
                        ></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div
        className="card"
        style={{ overflow: "hidden", position: "relative" }}
      >
        <div class="container">
          <h6 className="resource-list-title no-item-card">
            {t("CommonText.NoItem")}
          </h6>
        </div>
      </div>
    );
  };

  editEquipmentServiceType = (item) => {
    const { dispatch } = this.props;
    dispatch({ type: "EditEquipmentDetails", data: true });
    dispatch({ type: "EquipmentServiceTypeDetail", data: item });
    // this.props.history.push(`/Home/ShipDetails/EquipmentEdit/${equipmentDetail.shipEquipmentId}/${type}`);
  };
}

function mapStateToProps(state) {
  return {
    VendorEquipmentDetailList:
      state.VendorManagementReducer.VendorEquipmentDetailList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorManagementDetails)));
